/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import iconList from '../../assets/svg/LeftMenuIcons';
import configEnv from '../../config';

const baseURL = '/account';

// TODO: My Account's menu need to be store in content stack
const listItem = (brandIconColor, desktop, isAccountWalletV2Enabled = false) => {
    // /gifthistory-home-steaks // STY
    // /gifthistory-home-bakery // WLF
    // /gifthistory-home-cookies // CCO
    // /gifthistory-home-gift-baskets // H&D
    const { POLICY_CHOICES_URL } = configEnv;
    if (desktop) {
        return [
            {
                id: 1,
                label: 'Your Favorites',
                url: `${baseURL}/favorite`,
                icon: iconList(brandIconColor).favorite,
            },
            {
                id: 2,
                label: 'Account Overview',
                url: `${baseURL}/account`,
                icon: iconList(brandIconColor).overview,
            },
            {
                id: 3,
                label: 'Profile & Password',
                url: `${baseURL}/profile`,
                icon: iconList(brandIconColor).profileAndPassword,
            },
            {
                id: 4,
                label: 'Celebrations Passport®',
                url: `${baseURL}/passport`,
                userRole: 'P',
                icon: iconList(brandIconColor).passport,
            },
            {
                id: 5,
                label: 'Contacts & Reminders',
                url: `${baseURL}/address-book`,
                icon: iconList(brandIconColor).addressBook,
            },
            {
                id: 6,
                label: 'Order History',
                url: `${baseURL}/orders`,
                icon: iconList(brandIconColor).orders,
            },
            {
                id: 7,
                label: 'Subscriptions',
                url: `${baseURL}/subscriptions`,
                flag: 'is-account-subscription-enabled',
                icon: iconList(brandIconColor).subscriptions,
            },
            {
                id: 8,
                label: 'Gift List',
                url: `${baseURL}/gift-list`,
                regEx: /^\/gifthistory-home-(gift-baskets|steaks|bakery|cookies)\??/,
                flag: 'is-account-gift-list-enabled',
                icon: iconList(brandIconColor).giftList,
            },
            {
                id: 9,
                label: isAccountWalletV2Enabled ? 'Wallet' : 'Payments',
                url: `${baseURL}/billing-address`,
                icon: iconList(brandIconColor).paymentAndBilling,
            },
            {
                id: 10,
                label: 'Communication Center',
                url: `${baseURL}/email-preference`,
                icon: iconList(brandIconColor).emailPreference,
            },
            {
                id: 11,
                label: 'Privacy Choices',
                url: POLICY_CHOICES_URL,
                icon: iconList(brandIconColor).policy,
                flag: 'is-account-privacy-choices-tab-showing',
                type: 'external-new-tab',
            },
            {
                id: 12,
                label: 'Sign Out',
                url: '/auth/logout',
                icon: iconList(brandIconColor).signOut,
            },
        ];
    }
    return [
        {
            id: 1,
            label: 'Your Favorites',
            url: `${baseURL}/favorite`,
            icon: iconList(brandIconColor).favorite,
        },
        {
            id: 2,
            label: 'Change Password',
            url: `${baseURL}/change-password`,
            icon: iconList(brandIconColor).profileAndPassword,
        },
        {
            id: 3,
            label: 'Change Account Email',
            url: `${baseURL}/change-email`,
            icon: iconList(brandIconColor).changeEmail,
        },
        {
            id: 4,
            label: 'Celebrations Passport®',
            url: `${baseURL}/passport`,
            userRole: 'P',
            icon: iconList(brandIconColor).passport,
        },
        {
            id: 5,
            label: 'Contacts & Reminders',
            url: `${baseURL}/address-book`,
            icon: iconList(brandIconColor).addressBook,
        },
        {
            id: 6,
            label: 'Order History',
            url: `${baseURL}/orders`,
            icon: iconList(brandIconColor).orders,
        },
        {
            id: 7,
            label: 'Subscriptions',
            url: `${baseURL}/subscriptions`,
            flag: 'is-account-subscription-enabled',
            icon: iconList(brandIconColor).subscriptions,
        },
        {
            id: 8,
            label: 'Gift List',
            url: `${baseURL}/gift-list`,
            regEx: /^\/gifthistory-home-(gift-baskets|steaks|bakery|cookies)\??/,
            flag: 'is-account-gift-list-enabled',
            icon: iconList(brandIconColor).giftList,
        },
        {
            id: 9,
            label: isAccountWalletV2Enabled ? 'Wallet' : 'Payments',
            url: `${baseURL}/billing-address`,
            icon: iconList(brandIconColor).paymentAndBilling,
        },
        {
            id: 10,
            label: 'Communication Center',
            url: `${baseURL}/email-preference`,
            icon: iconList(brandIconColor).emailPreference,
        },
        {
            id: 11,
            label: 'Privacy Choices',
            url: POLICY_CHOICES_URL,
            icon: iconList(brandIconColor).policy,
            flag: 'is-account-privacy-choices-tab-showing',
            type: 'external-new-tab',
        },
        {
            id: 12,
            label: 'Sign Out',
            url: '/auth/logout',
            icon: iconList(brandIconColor).signOut,
        }];
};

export default listItem;
